import {Inject, Injectable} from '@angular/core';
import {UserVerification} from '../model/cycle-verification.model';
import {CplCycle} from '../model/cpl-cycle.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class VerifyApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    verify(cycleVerification: UserVerification[]) {
        return this.http.post(this.baseUri + '/verify', cycleVerification);
    }

    submitForVerification(userCycle: CplCycle) {
        return this.http.post(this.baseUri + '/verify/submitForVerification', userCycle, { responseType: 'text' });
    }

    getVerifyHistoryForSupervisors(userCycleId: string) {
        return this.http.get(this.baseUri + '/verify/history/supervisor/' + userCycleId);
    }

    getVerifyHistoryForEndUser(userCycleId: string) {
        return this.http.get(this.baseUri + '/verify/history/endUser/' + userCycleId);
    }
}